var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiLightBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.89,
    y: 1.62,
    className: "st2",
    width: 0.29,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.64,
    y: 1.37,
    className: "st2",
    width: 0.79,
    height: 13.17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.31,4C7.64,4,7.09,3.46,7.09,2.78s0.55-1.22,1.22-1.22s1.22,0.55,1.22,1.22S8.98,4,8.31,4z M8.31,2.07 c-0.4,0-0.72,0.32-0.72,0.72c0,0.4,0.32,0.72,0.72,0.72s0.72-0.32,0.72-0.72C9.03,2.39,8.71,2.07,8.31,2.07z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.31,7.4c-0.67,0-1.22-0.55-1.22-1.22s0.55-1.22,1.22-1.22s1.22,0.55,1.22,1.22S8.98,7.4,8.31,7.4z  M8.31,5.46c-0.4,0-0.72,0.32-0.72,0.72S7.91,6.9,8.31,6.9s0.72-0.32,0.72-0.72S8.71,5.46,8.31,5.46z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.31,10.87c-0.67,0-1.22-0.55-1.22-1.22s0.55-1.22,1.22-1.22s1.22,0.55,1.22,1.22S8.98,10.87,8.31,10.87z  M8.31,8.93c-0.4,0-0.72,0.32-0.72,0.72s0.32,0.72,0.72,0.72s0.72-0.32,0.72-0.72S8.71,8.93,8.31,8.93z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.31,14.33c-0.67,0-1.22-0.55-1.22-1.22s0.55-1.22,1.22-1.22s1.22,0.55,1.22,1.22S8.98,14.33,8.31,14.33z  M8.31,12.4c-0.4,0-0.72,0.32-0.72,0.72s0.32,0.72,0.72,0.72s0.72-0.32,0.72-0.72S8.71,12.4,8.31,12.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLightBar);
export default __webpack_public_path__ + "static/media/Multi-LightBar.e0808d7ec0077d3ef94623bf907eebe5.svg";
export { ForwardRef as ReactComponent };